import React from "react";
import MenuItem from 'material-ui/MenuItem';
import Drawer from "material-ui/Drawer";
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import mdEntityService from "core/metamodel/mdEntityService";
import {ErrorComp} from "core/components/errorComp/errorComp";
import {preSave, lovValue, IDomainObject, FormProps, pickLov} from "core/form/formUtils";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import eventService from "core/event/eventService";
import EventTemplateForm from "core/event/component/eventTemplateForm";
import DocumentTemplateResourceList from 'core/document/component/documentTemplateResourceList';
import SvgMoreVert from "material-ui/svg-icons/navigation/more-vert";
import {ZzIconButtonMenu} from "core/components/buttons/icons";
import {screenSm} from "core/common/config/variables";
import {Validate} from 'core/form/validate';
import MdField from 'core/metamodel/mdField';
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {optionsSearch} from "core/common/service/commonDataService";
import {EmailEventHistory} from "core/event/component/historyBlocks";
import {MdCheckbox} from 'core/components/fields/fields';
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {EventTemplate, EventTest} from "core/event/eventDomain";
import uiService from "core/common/service/uiService";
import {action} from "mobx";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import FlatButton from "material-ui/FlatButton";
import {VALUESOURCETYPE} from "core/metamodel/mdField";
import {DATATYPE} from "core/metamodel/mdField";
import MdEntity from "core/metamodel/mdEntity";
import {FIELDDEFDISPLAYTYPE} from "core/form/form";
import {loc} from "core/common/config/locales";


let AceEditor;


interface EventTemplateDetailState {
  openTestDrawer?: boolean
}

@observer
export default class EventTemplateDetail extends PageAncestor<PageProps, EventTemplateDetailState> {

  static module = MODULE.core;
  static title = 'Event Template';
  static icon = 'file-code-o';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("EventTemplateDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['EventTemplate', "DocumentTemplateResource"], [{entity: 'MdEntity', lov: true}]);

    let eventPromise: Promise<EventTemplate>;

    if (routerParams.id === 'new') {
      eventPromise = Promise.resolve(new EventTemplate({$new: true, eventType: pickLov(query)} as any));
    } else {
      eventPromise = eventService.readEventTemplate(routerParams.id);
    }

    // webpack to takhle promisifikovane nezvladne, musi to byt normalne, je to v willMount
    // const requireEnsure = (dependencies, filename) => new Promise((resolve, reject) => {
    //     require.ensure(dependencies, resolve, filename);
    //   });
    //
    // let requirePromise = requireEnsure(['brace', 'react-ace', 'brace/mode/xml', 'brace/theme/github'], 'reactAce');


    return Promise.all([metadataPromise, eventPromise])
      .then(([entityMap, eventTemplateObject]: [any, EventTemplate]) => {
        eventService.eventTemplateObject = eventTemplateObject.initAfterRead(false);
        if (eventService.eventTemplateObject.defaultEmailBody == null) {
          eventService.eventTemplateObject.defaultEmailBody = '';
        }
      });
  }

  state = {
    openTestDrawer: false
  };


  _aceEditorBody: React.ReactInstance;

  aceEditorBodyRefHandler = c => this._aceEditorBody = c;


  componentWillMount() {
    require.ensure(['react-ace', 'brace', 'brace/mode/html', 'brace/theme/github', 'brace/ext/searchbox'], (require) => {
      if (AceEditor) {
        return;
      }

      AceEditor = (require('react-ace') as any).default;
      const brace = require("brace");
      require('brace/mode/html');
      require('brace/theme/github');
      require('brace/ext/searchbox');


      this.forceUpdate();

    }, "reactAce");
  }


  componentWillUnmount() {
    eventService.eventTemplateObject = null;
  }


  customValidate = (eventTemplateObject) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return eventService.eventTemplateObject;
  }


  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    if (!preSave(eventService.eventTemplateObject, this.customValidate)) {
      return;
    }

    eventService.saveEventTemplate(eventService.eventTemplateObject.prepareForServer())
      .then(action("eventTemplateSave-callback", (eventTemplateJson: IDomainObject) => {
        let wasNew = eventService.eventTemplateObject.cleanAfterSave(eventTemplateJson);
        if (wasNew) {
          this.context.router.replaceWith('eventTemplateDetail', {id: eventService.eventTemplateObject.id});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        eventService.eventTemplateObject.$errors = error.getMessages();
      });

  };

  @action onDelete = (evt) => {
    console.log('onDelete');

    eventService.deleteEventTemplate(eventService.eventTemplateObject.eventType.value as string, eventService.eventTemplateObject.templateIndex)
      .then(response => {
        this.context.router.transitionTo('eventTypeDetail', {id: eventService.eventTemplateObject.eventType.value});
      }, error => {
        eventService.eventTemplateObject.$errors = error.getMessages();
      })
  };

  onAdd = (evt) => {
    console.log('onAdd');
    this.context.router.transitionTo("eventTemplateDetail", {id: 'new'}, eventService.eventTemplateObject.eventType);
  };




  @action onChangeDefaultEmailBody = (newValue) => {
    console.log('onChangeDefaultEmailBody');
    eventService.eventTemplateObject.defaultEmailBody = newValue;
    eventService.eventTemplateObject.$dirty = true;
  };


  handleTest = (evt) => {
    eventService.eventTemplateObject.$testObject = new EventTest();
    this.setState({openTestDrawer: true});
  };

  handleTestRequestChange = (evt) => {
    this.setState({openTestDrawer: false});
  };




  render() {

    const {
      query
    } = this.props;


    const propsForCreateForm = {
      dataObject: eventService.eventTemplateObject,
      rootObject: eventService.eventTemplateObject,
      entity: mdEntityService.getEntity('EventTemplate'),
      entities: mdEntityService.entityMap
    };


    return (

      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        {this._createToolMenu(eventService.eventTemplateObject, query.gridLocation)}
        <ErrorComp messages={eventService.eventTemplateObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>

        { (this.state.openTestDrawer) ?
          <EventTestDrawer entities={mdEntityService.entityMap} open={this.state.openTestDrawer}
                           dataObject={eventService.eventTemplateObject.$testObject} rootObject={eventService.eventTemplateObject}
                           onRequestChange={this.handleTestRequestChange}/> : null }


        <form style={{marginTop: 10}}>

          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <EventTemplateForm {...propsForCreateForm}/>
            </div>
            <div className="col-xs-12 col-sm-6">
              <DocumentTemplateResourceList documentTemplateObject={eventService.eventTemplateObject}
                                            entities={mdEntityService.entityMap} showType/>
            </div>
          </div>


          <div>Email body template</div>
          <div className="row">
            <div className="col-xs-12">
              { (AceEditor) ?
                <AceEditor
                  mode="html"
                  theme="github"
                  value={eventService.eventTemplateObject.defaultEmailBody}
                  onChange={this.onChangeDefaultEmailBody}
                  name="DEFAULT_EMAIL_BODY"
                  enableBasicAutocompletion={true}
                  enableLiveAutocompletion={true}
                  editorProps={{$blockScrolling: true}}
                  width="100%"
                  maxLines="Infinity"
                  minLines={10}
                  style={{padding: '5px 0 0 0'}}
                  ref={this.aceEditorBodyRefHandler}
                />
                : "Loading...."}
            </div>
          </div>


        </form>

      </main>




    );
  }


  _createToolMenu(eventTemplateObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1}>
        <ZzFlatButton onClick={this.onSave} disabled={!eventTemplateObject.$dirty} label="Save" permission={eventTemplateObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={eventTemplateObject.$new} label="New" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="EventTemplate" pageAncestor={this} onClick={this.onDelete} disabled={eventTemplateObject.$new} label="Delete" permission={PERMISSION.Delete}/>

        <ZzIconButtonMenu buttonIcon={<SvgMoreVert/>}>
          <MenuItem primaryText="Test" key={1} onClick={this.handleTest}/>
        </ZzIconButtonMenu>


      </Toolmenu>
    );
  }

}


interface EventTestDrawerFormProps extends FormProps<EventTest, EventTemplate> {
  onRequestChange: any;
}

@createForm({
  formName: 'EventTemplateTestForm',
  fields: [{
    name: '$mdEntity',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Type of object to test', valueSource: 'MdEntity', valueSourceType: VALUESOURCETYPE.LOCAL})
  }, {
    name: '$testObject',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Test Object', valueSourceType: VALUESOURCETYPE.ASYNC})
  }, {
    name: '$sendEmail',
    displayType:FIELDDEFDISPLAYTYPE.checkbox,
    mdField: new MdField({label: 'Send email', dataType: DATATYPE.BOOLEAN})
  }]
}, () => <noscript/>)
@observer
class EventTestDrawer extends React.Component<EventTestDrawerFormProps, undefined> {

  handleTest = () => {
    let {entities, dataObject, rootObject} = this.props;
    eventService.test(rootObject, dataObject.$mdEntity, lovValue(dataObject.$testObject), !dataObject.$sendEmail)
      .then(eventHistory => {
        dataObject.$eventHistory = eventHistory;
      });
  };



  render() {

    let {entities, open, onRequestChange, dataObject, rootObject, formName} = this.props;

    let {$mdEntity, $testObject, $sendEmail} = dataObject.getFormFields(formName);


    let screenWidth = document.body.getBoundingClientRect().width;

    return (
      <Drawer openSecondary open={open}
              width={((screenWidth < screenSm) ? 0.9 : 0.6) * screenWidth}
              docked
              onRequestChange={onRequestChange}
              containerStyle={{paddingTop: 40, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}
      >


        <div style={{margin: 20}}>
          <div className="row">
            <div className="fx col-xs-12">
              <StyledSelect {...$mdEntity.props}  />
              <Validate field={$mdEntity} value={$mdEntity.props.value}/>
            </div>
          </div>
          { (dataObject.$mdEntity) ? (
            <div className="row">
              <div className="fx col-xs-12">
                <StyledSelect  {...$testObject.props} async={true}
                               loadOptions={optionsSearch.bind(this, lovValue(dataObject.$mdEntity), {})}
                               clearable={true}/>
                <Validate field={$testObject} value={$testObject.props.value}/>
              </div>
            </div>
          ) : null }

          { (dataObject.$mdEntity) ? (
            <div className="row">
              <div className="fx col-xs-12 col-sm-4">
                <MdCheckbox {...$sendEmail.props} />
              </div>
            </div>
          ) : null }

          { (dataObject.$eventHistory) ? (
            <EmailEventHistory eventHistory={dataObject.$eventHistory}/>
          ) : null}
        </div>

        <div style={{margin: 20}}>
          <FlatButton label={loc.i18n`Close`} primary onClick={onRequestChange}/>
          <FlatButton label={loc.i18n`Test`} secondary onClick={this.handleTest}/>
        </div>


      </Drawer>
    )

  }

}






// WEBPACK FOOTER //
// ./src/core/event/eventTemplateDetail.tsx